"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkThemes = exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _index = require("../LexusButton/index.styled");
var _LexusTypography = require("../LexusTypography");
var _Typography = _interopRequireDefault(require("../Typography"));
const {
  ToyotaType
} = require("../ToyotaTypography");
const linkThemes = exports.linkThemes = {
  PrimaryBlack: `
    color: #000;
    &:after {
      background: #000;
    }
  `,
  PrimaryWhite: `
    color: #FFF;
    &:after {
      background: #FFF;
    }
  `,
  PrimaryGold: `
    color: #a48b5b;
    &:after {
      background: #a48b5b;
    }
  `,
  ToyotaRed: `
    color: #e10a1d;
    border: none;
    ${ToyotaType({
    weight: "semibold",
    sizing: "heading05",
    spacing: "normal"
  })}
    &[disabled] {
      color: #666;
    }
    &:after {
      background: transparent;
    }
  `,
  default: "",
  SecondaryBlack: "",
  SecondaryWhite: "",
  SecondaryGold: "",
  GRPrimaryBlack: `
    color: #000;
    ${(0, _LexusTypography.akkuratMono)({
    sizing: "subheading16"
  })}
  `,
  GRPrimaryWhite: `
    color: #FFF;
      ${(0, _LexusTypography.akkuratMono)({
    sizing: "subheading16"
  })}
  `,
  GRPrimaryRed: `
    color: #E60010;
      ${(0, _LexusTypography.akkuratMono)({
    sizing: "subheading16"
  })}
  `
};
linkThemes.default = linkThemes.PrimaryBlack;
linkThemes.SecondaryBlack = linkThemes.PrimaryBlack;
linkThemes.SecondaryWhite = linkThemes.PrimaryWhite;
linkThemes.SecondaryGold = linkThemes.PrimaryGold;
const mobileExperience = {
  anchor: {
    sideToSide: `
    `,
    stacked: `
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 0;
    `,
    default: ""
  },
  button: {
    sideToSide: `
      &:last-child {
        margin-right: 0px;
      }
    `,
    stacked: `
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    default: ""
  }
};
mobileExperience.button.default = mobileExperience.button.sideToSide;
mobileExperience.anchor.default = mobileExperience.anchor.sideToSide;
var _default = exports.default = {
  CTAContainer: _styledComponents.default.div`
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 54px;
    ${(0, _breakpoints.default)("mobile")} {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      bottom: 0;
    }
  `,
  Row: _styledComponents.default.div`
    ${(0, _breakpoints.default)("mobile")} {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
    }
    & + & {
      margin-top: 20px;
      ${(0, _breakpoints.default)("tablet", "up")}{
        margin-top: 25px;
      }
    }
  `,
  // @ts-ignore
  AnchorWrapper: (0, _styledComponents.default)(_Typography.default.button)`
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
    ${(0, _breakpoints.default)("mobile")} {
      ${function (_ref) {
    let {
      $ctaMobileExperience
    } = _ref;
    return mobileExperience.anchor[$ctaMobileExperience] || mobileExperience.anchor.default;
  }};
    }
    a, button {
      text-decoration: underline;
      text-underline-offset: 2px;
      text-decoration-thickness: 1px;
      position: relative;
      display: inline-block;
      padding-bottom: 1px;
      ${function (_ref2) {
    let {
      theme
    } = _ref2;
    return linkThemes[theme] || linkThemes.default;
  }}
    }
  `,
  CTAWrapper: _styledComponents.default.div`
    display: inline-block;
    vertical-align: top;
    &:last-child {
      margin-right: 0;
    }
    ${(0, _breakpoints.default)("mobile")} {
      ${function (_ref3) {
    let {
      $ctaMobileExperience
    } = _ref3;
    return mobileExperience.button[$ctaMobileExperience] || mobileExperience.button.default;
  }};
      a, button {
        &:not(:has(${_index.TextWrapper})) {
          width: 150px;
          padding: 0 10px;
          min-width: auto;
        }
      }
    }
    ${(0, _breakpoints.default)("tablet")} {
      a, button {
        min-width: 220px;
        ${function (_ref4) {
    let {
      $buttonSize
    } = _ref4;
    if ($buttonSize === "small" || $buttonSize === "toyota") {
      return `
            min-width: initial;
        `;
    }
    return `
        min-width: default;
    `;
  }}
      }
    }
  `,
  CTAListWrapper: _styledComponents.default.div`
    display: ${function (_ref5) {
    let {
      $displayType
    } = _ref5;
    return $displayType;
  }};
    width: ${function (_ref6) {
    let {
      $displayType
    } = _ref6;
    return $displayType === "block" ? "100%" : "auto";
  }};
  `,
  Bucket: _styledComponents.default.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    ${function (_ref7) {
    let {
      $alignCtas
    } = _ref7;
    return $alignCtas === "center" ? `
    justify-content: center;
    margin: 0 10px 0 10px;
    ` : $alignCtas === "full-width" ? `
      flex-wrap: nowrap;
      justify-content: center;
      width: 100%;
      & .cta-wrapper {
        flex-grow: 1;
      }
      & .lexus-button {
        display: flex;
        width: 100%;
      }
    ` : `
    justify-content: left;
  `;
  }}

    &:not(:first-child) {
      padding-top: 20px;
    }
  `
};